<div class="fp-customer-details-container">
  <div class="fp-logo" aria-hidden="true" role="img">
    <img alt="freshpass logo" aria-hidden="true" class=""
      src="ocsp-web-ui/dist/assets/images/freshpass-logo-v2.svg" />
  </div>
  <div class="fp-customer-details-main">
    <div aria-level="1" class="fp-customer-details-title" role="heading">
      {{freshpassTitle}}<sup>®</sup>
    </div>
    <div *ngIf="displaySubTypeLink" class="fp-customer-details-sub-type">
      <a [routerLink]="subTypeLink" class="fp-customer-details-link">
      {{userCustomerDetails.subscriptionType}}
      <span aria-hidden="true" class="img-subs" role="img">
        <img alt="right arrow icon" aria-hidden="true" class="fp-customer-details-right-arrow"
          src="ocsp-web-ui/dist/assets/images/Chevron-right.svg" />
      </span>
      </a>
    </div>
    <div class="fp-customer-details-copy">
      {{ freshpassBenefitsDescription }}
    </div>
  </div>
  <div class="fp-savings-details-container">
    <div class="fp-lifetime-savings-container" aria-labelledby="savingsLabel savingsValue">
      <div id="savingsValue" class="fp-lifetime-saved">${{userCustomerDetails.lifeSavings}}</div>
      <div id="savingsLabel" class="fp-lifetime-saved-description">
        {{LIFETIMESAVINGS_TEXT}}
          <span class="tooltip-container">
            <button aria-expanded="false" aria-label="View personalized savings info"
                    class="noBgBrdr freshPassTooltip" data-original-title="<div class=&#34;tooltip-title-container&#34;>
                <span class=&#34;tooltip-title&#34;></span>
                <span id=&#34;tooltip-close-container-id&#34; class=&#34;tooltip-close-container&#34; role=&#34;button&#34; tabindex=&#34;0&#34; aria-label=&#34;close tooltip&#34;><img class=&#34;svg-close-tooltip-icon&#34; src=&#34;ocsp-web-ui/dist/assets/images/icon/Web/close/white.svg&#34; aria-hidden=&#34;true&#34;alt=&#34;close icon&#34;></span></div>
                <span class=&#34;tooltip-inner-info-content&#34;>Total savings are calculated starting on 6/22/2022. If you subscribed to FreshPass<sup>®</sup> after this date, your total savings are calculated starting on your subscription date. Total savings calculation is based on discounts to grocery delivery fees and redemption of perks listed on the FreshPass<sup>®</sup> subscription page.</span>"
                    data-placement="top"
                    data-qa="freshPassTooltip" data-toggle="tooltip">
                <img alt="info icon image" class="info-icon" aria-hidden="true"
                     role="presentation" src="ocsp-web-ui/dist/assets/images/info_icon_2.png"/>
            </button>
          </span>
      </div>
    </div>
    <div class="fp-time-saved-container" aria-labelledby="timeSavingsLabel timeSavingsValue">
      <div id="timeSavingsValue" class="fp-lifetime-saved">{{userCustomerDetails.timeSavings}}</div>
      <div id="timeSavingsLabel" class="fp-lifetime-saved-description">{{HOURSSAVED_TEXT}}</div>
    </div>
  </div>
</div>

<hr class="customer-details-hr" />
